import exifr from 'exifr';

export const removeExif = async (file) => {
    return new Promise((resolve, reject) => {
      if (!file || !file.type.startsWith('image/')) {
        resolve(file);
        return;
      }

      const reader = new FileReader();

      reader.onload = async (event) => {
        try {
          const imageDataUrl = event.target.result;
          // OLD: const modifiedDataUrl = await removeExifData(imageDataUrl);
          // NEW: pass the type so a PNG is re-encoded as PNG (backend checks bytes match the extension)
          const modifiedDataUrl = await removeExifData(imageDataUrl, file.type);
          const modifiedFile = await dataUrlToFile(modifiedDataUrl, file.name, file.type);
          resolve(modifiedFile);
        } catch (error) {
          reject(error);
        }
      };

      reader.onerror = (error) => {
        reject(error);
      };

      reader.readAsDataURL(file);
    });
  }

  // OLD: const removeExifData= async(imageDataUrl) => {
  const removeExifData= async(imageDataUrl, fileType) => {
    const image = new Image();
    image.src = imageDataUrl;

    return new Promise((resolve, reject) => {
      image.onload = () => {
        const canvas = document.createElement('canvas');
        const context = canvas.getContext('2d');
        canvas.width = image.width;
        canvas.height = image.height;
        context.drawImage(image, 0, 0);

        // Get EXIF data
        exifr.parse(imageDataUrl)
          .then((exifData) => {
            if (exifData) {
                console.log(exifData)
              // Clear EXIF and GPS data
              delete exifData['GPS'];
              delete exifData['Exif.GPSInfo'];
              delete exifData['Exif'];

              // Convert modified image data back to Data URL
              // OLD: always JPEG, so "x.png" was uploaded with JPEG bytes and the backend rejected it
              // const modifiedDataUrl = canvas.toDataURL('image/jpeg');
              const outputType = fileType === 'image/png' ? 'image/png' : 'image/jpeg';
              console.warn('[EXIF_STRIP] re-encoding history image as', outputType, 'original type:', fileType);
              const modifiedDataUrl = canvas.toDataURL(outputType);
              resolve(modifiedDataUrl);
            } else {
              // No EXIF data found, return original image data URL
              resolve(imageDataUrl);
            }
          })
          .catch((error) => {
            reject(error);
          });
      };

      image.onerror = (error) => {
        reject(error);
      };
    });
  }

  const dataUrlToFile = (dataUrl, fileName, fileType) => {
    return fetch(dataUrl)
      .then((res) => res.blob())
      .then((blob) => new File([blob], fileName, { type: fileType }));
  }